<template>
  <section>
  <a class="donation-nav donation-nav--rewind" href="#" @click.prevent="goBack">voltar</a>
    <div class="input-wrapper"
      v-for="(message, index) in messages"
      v-if="message.type == 'msg'"
      v-html="message.text"
      :key="index"></div>
    <div class="donation-nav-wrap">
      <div class="input-wrapper"
        v-for="(message, index) in messages"
        v-if="message.type == 'link'"
        :key="index">
        <a target="_blank" class="donation-nav donation-nav--block"
          :href="message.href">
          {{ message.text }}
        </a>
      </div>
    </div>
    <ul id="wrap-share">
      <li>
        <a class="twitter" href="https://twitter.com/intent/tweet?text=Ajude%20o%20Ciro%20a%20mudar%20o%20Brasil%21%20https%3A%2F%2Fdoe.cirogomes.com.br%3Fref%3Dagradecimento">Compartilhar</a>
      </li>
      <li>
        <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdoe.cirogomes.com.br%3Fref%3Dagradecimento&src=sdkpreparse" class="fb-xfbml-parse-ignore facebook">Compartilhar</a>
      </li>
    </ul>
    <p class="contact-message">
      <a href="mailto:doe@cirogomes.com.br">
        Você deseja enviar uma mensagem para a Equipe do Ciro?
      </a>
      Sua opinião vale tanto quanto sua contribuição.
    </p>
  </section>
</template>

<script>
export default {
  name: 'finalMessage',
  computed: {
    messages() {
      return this.$store.state.messages;
    },
  },
  mounted() {
    const form = document.getElementById('donation-form');
    form.scrollIntoView({ block: 'start', behavior: 'smooth' });
    this.scrollToDonate();
  },
  methods: {
    scrollToDonate() {
      const form = document.getElementById('doar');
      form.scrollIntoView({ block: 'start', behavior: 'smooth' });
    },
    redirectUser(ui) {
      if (ui.value === 'pay_with_cc') {
        this.$router.replace(this.$route.path);
        this.$store.dispatch('CHANGE_PAYMENT_STEP', {
          step: 'userData',
        });
      } else {
        sessionStorage.clear();
        window.open(ui.href);
      }
    },
    goBack() {
      this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'selectValue' });
    },
  },
};
</script>
